import Layout from "@/components/Layout";
import PageHead from "@/components/PageHead";
import AnimatedSection from "@/components/AnimatedSection";

const issues = [
  {
    title: "Complex Merger Antitrust Risk Assessment",
    desc: "Advising companies on antitrust risk analysis for complex mergers involving overlapping product markets and concentrated industries, including pre-filing strategy and regulatory engagement.",
  },
  {
    title: "Government Investigation Defense",
    desc: "Representing clients in government investigations conducted by the Department of Justice and Federal Trade Commission, including responding to civil investigative demands and negotiating with enforcement staff.",
  },
  {
    title: "Distribution Systems and Pricing Counseling",
    desc: "Providing ongoing counseling regarding distribution systems, dealer relationships, pricing practices, and discount programs to ensure compliance with antitrust requirements.",
  },
  {
    title: "Federal Antitrust Litigation",
    desc: "Defending companies in federal antitrust litigation, including monopolization claims, competitor disputes, and class action matters involving pricing and distribution practices.",
  },
  {
    title: "Competition Policy Analysis for Major Industries",
    desc: "Analyzing competition policy developments affecting major industries including technology, healthcare, life sciences, and manufacturing, providing strategic guidance for corporate leadership.",
  },
  {
    title: "Private Equity Antitrust Advisory",
    desc: "Advising private equity firms and investment funds on antitrust considerations in portfolio company acquisitions, roll-up strategies, and investment decisions.",
  },
  {
    title: "Consumer Protection Investigation Strategy",
    desc: "Developing strategy for companies facing consumer protection investigations relating to unfair competition or deceptive business practices at the federal and state level.",
  },
  {
    title: "Joint Venture and Competitor Collaboration Review",
    desc: "Counseling companies on antitrust implications of joint ventures, competitor collaborations, and industry group activities to manage competitive risk.",
  },
];

const RepresentativeIssues = () => (
  <Layout>
    <PageHead title="Representative Antitrust Issues" description="Illustrative examples of complex antitrust matters where Alicia J. Batts and Batts Legal LLP provide strategic counsel to corporations and investors." path="/representative-issues" keywords="Alicia Batts antitrust cases, representative antitrust issues, antitrust counsel experience, competition law matters, Batts Legal representative work" />
    <section className="bg-hero text-primary-foreground py-20">
      <div className="editorial-container">
        <AnimatedSection animation="fade"><div className="gold-accent-line mb-6" /></AnimatedSection>
        <AnimatedSection animation="fade-up" delay={100}><h1 className="text-4xl md:text-5xl font-serif font-semibold mb-4">Representative Issues</h1></AnimatedSection>
        <AnimatedSection animation="fade-up" delay={200}><p className="text-lg opacity-80 max-w-2xl">Illustrative examples of the complex antitrust matters where Batts Legal LLP provides strategic counsel.</p></AnimatedSection>
      </div>
    </section>

    <section className="section-padding">
      <div className="editorial-container">
        <div className="grid md:grid-cols-2 gap-6">
          {issues.map((issue, i) => (
            <AnimatedSection key={issue.title} animation="fade-up" delay={i * 80}>
              <div className="bg-card rounded-md p-8 shadow-card border border-border h-full">
                <div className="gold-accent-line mb-4" />
                <h3 className="font-serif text-lg font-semibold text-foreground mb-3">{issue.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{issue.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  </Layout>
);

export default RepresentativeIssues;
